import { Link } from "react-router-dom";
import { FaArrowLeft, FaTags } from "react-icons/fa";
import { CategoryDefinitionsBrowser } from "@/components/PhysicalRecords/PhysicalRecordCategories";
import { usePageTitle } from "@/hooks/usePageTitle";

export default function AdminPhysicalRecordsCategories() {
  usePageTitle(null, "Physical Records Categories");
  return <div className="container py-4">
    <Link className="btn btn-sm btn-outline-secondary mb-3" to="/admin/physical-records"><FaArrowLeft aria-hidden="true" /> Physical Records Admin</Link>
    <h1 className="h4 mb-3"><FaTags aria-hidden="true" /> Category Definitions</h1>
    <CategoryDefinitionsBrowser />
  </div>;
}